import { ClarityUnmaskDirective } from 'app/shared/directives/clarity-unmask.directive';
import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalData } from '@interfaces/ModalData';

@Component({
  selector: 'gd-custom-modal',
  templateUrl: './custom-modal.component.html',
  styleUrls: ['./custom-modal.component.scss'],
  standalone: true,
  imports: [
    ClarityUnmaskDirective,
    CommonModule,
    MatCardModule,
    MatButtonModule,
  ],
})
export class CustomModalComponent {
  constructor(
    private dialogRef: MatDialogRef<CustomModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalData,
  ) {}

  onAcceptAction(): void {
    this.dialogRef.close(true);
  }
  onRejectAction(): void {
    this.dialogRef.close(false);
  }

  onAction(value: unknown): void {
    this.dialogRef.close(value);
  }
}
